import { useMemo } from 'react';
import { NetworkData, NodeType } from '../types/cytoscape';
import cytoscape from 'cytoscape';

export const useNetworkElements = (
  data: NetworkData | null,
  searchedNodeIds: Set<string> = new Set(),
  selectedNodeIds: Set<string> = new Set(),
  fixedNodes: Set<string> = new Set()
) => {
  return useMemo<cytoscape.ElementDefinition[]>(() => {
    if (!data || !data.nodes || !data.edges) {
      return [];
    }

    const nodes = data.nodes.map((node) => ({
      data: {
        ...node,
        highlighted: searchedNodeIds.has(node.id),
        isSelected: selectedNodeIds.size > 0 && selectedNodeIds.has(node.id),
      },
      group: 'nodes' as const,
      classes: [
        node.nodeType || '',
        node.nodeType === NodeType.SOCIAL_ISSUE ||
        node.nodeType === NodeType.CROSS_ISSUE
          ? 'social-issue'
          : '',
        fixedNodes.has(node.id) ? 'fixed' : '',
        searchedNodeIds.has(node.id) ? 'highlighted' : '',
        selectedNodeIds.size > 0 && selectedNodeIds.has(node.id)
          ? 'selected'
          : '',
      ]
        .filter(Boolean)
        .join(' '),
      locked: fixedNodes.has(node.id),
    }));

    const edges = data.edges.map((edge) => ({
      data: {
        ...edge,
        highlighted:
          searchedNodeIds.has(edge.source) || searchedNodeIds.has(edge.target),
      },
      group: 'edges' as const,
      classes: [
        searchedNodeIds &&
          (searchedNodeIds.has(edge.source) ||
            searchedNodeIds.has(edge.target)) &&
          'highlighted',
      ]
        .filter(Boolean)
        .join(' '),
    }));

    return [...nodes, ...edges];
  }, [data, selectedNodeIds, searchedNodeIds, fixedNodes]);
};
